import axios, { AxiosResponse } from 'axios'
import Jsona from 'jsona'

import { NotificationCenterHeaderName, NotificationCenterLog } from '@/entities/NotificationCenter/NotificationCenter'
import { formatDate } from '@/helpers/date'
import { ExchangeResource, Shift } from '@/models'
import { DateFormat } from '@/types'

const withEventLogHeader = (eventLogTrackerData?: NotificationCenterLog) => (
    eventLogTrackerData
        ? {
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        }
        : {}
)

const jsonApiDataFormatter = new Jsona()

type JsonaModel = Parameters<Jsona['serialize']>[0]['stuff']

export const getPlannedShifts = (includes: string[], startDate: Date, endDate: Date): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/shifts/planned`,
    {
        params: {
            include: includes.join(','),
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
        },
    },
)

export const getOpenShifts = (includes: string[], startDate: Date, endDate: Date): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/shifts/open`,
    {
        params: {
            include: includes.join(','),
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
        },
    },
)

export const offerShift = (shiftId: string, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => axios.post(
    `${process.env.REACT_APP_API_URL}/me/shift/offer/${shiftId}`,
    undefined,
    withEventLogHeader(eventLogTrackerData),
)

export const cancelShiftOffer = (shift: Shift, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => axios.delete(
    `${process.env.REACT_APP_API_URL}/me/shift/offer/${shift.id}`,
    withEventLogHeader(eventLogTrackerData),
)

export const registerShiftOffer = (shift: ExchangeResource, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => axios.post(
    `${process.env.REACT_APP_API_URL}/me/shift/register-offer/${shift.id}`,
    undefined,
    withEventLogHeader(eventLogTrackerData),
)

export const unregisterShiftOffer = (shift: ExchangeResource, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => axios.delete(
    `${process.env.REACT_APP_API_URL}/me/shift/register-offer/${shift.id}`,
    withEventLogHeader(eventLogTrackerData),
)

export const addCommentToShift = (comment: JsonaModel): Promise<AxiosResponse> => axios.post(
    `${process.env.REACT_APP_API_URL}/me/comment`, jsonApiDataFormatter.serialize({
        stuff: comment,
        includeNames: ['shiftPlannings'],
    }),
)
